<div class="page-content">
  <div id="earth_div"></div>
  <img [src]="'/assets/logo-big.svg'" alt="">

  <div class="button-container">
    <button class="custom-button" type="button" (click)="goToPage()">Start</button>
  </div>
</div>
